var render = function render(){var _vm=this,_c=_vm._self._c;return _c('export-excel',{staticClass:"export_btn",attrs:{"title":_vm.title,"fields":_vm.custom_fields,"fetch":_vm.getData,"type":"csv","footer":_vm.footer,"name":`FORM 7 Export from ${_vm.twoDate.startDate} to ${_vm.twoDate.endDate}.xls`}},[_c('v-icon',{attrs:{"color":"white","left":""}},[_vm._v("mdi-chevron-right-circle-outline")]),_vm._v("Export ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }